import { Icons } from 'components/Icon';
import { STEPS } from './steps';
import BankImage from '../assets/assets/bank.png';
import StockImage from '../assets/assets/stocks.png';
import RSAImage from '../assets/assets/rsa.png';
import BondImage from '../assets/assets/bonds.png';
import OtherImage from '../assets/assets/other-assets.png';
import EmployeeImage from '../assets/assets/employee-benefit.png';

export const DashboardStat = [
  {
    pageId: STEPS.BANK_INFORMATION,
    name: 'Bank Account',
    icon: Icons.Bank,
    bankName: 'Lorem Ipsum',
    accountNumber: '1234567890',
    percentage: 30,
    pageUrl: 'beneficiary/assign/bank'
  },
  {
    pageId: STEPS.STOCK_INFORMATION,
    name: 'Stocks/Shares',
    icon: Icons.Stocks,
    bankName: 'Lorem Ipsum',
    accountNumber: '1234567890',
    percentage: 30,
    pageUrl: 'beneficiary/assign/stock'
  },
  {
    pageId: STEPS.PENSION_INFORMATION,
    name: 'Pension Fund Account',
    icon: Icons.Pension,
    bankName: 'Lorem Ipsum',
    accountNumber: '1234567890',
    percentage: 30,
    pageUrl: 'beneficiary/assign/pension'
  },
  {
    pageId: STEPS.PHYSICAL_ASSETS_INFORMATION,
    name: 'Physical Asset',
    icon: Icons.Pension,
    bankName: 'Lorem Ipsum',
    accountNumber: '1234567890',
    percentage: 30,
    pageUrl: 'beneficiary/assign/physical'
  },
  {
    pageId: STEPS.BOND_INFORMATION,
    name: 'Bond',
    icon: Icons.Pension,
    bankName: 'Lorem Ipsum',
    accountNumber: '1234567890',
    percentage: 30,
    pageUrl: 'beneficiary/assign/bond'
  },
  {
    pageId: STEPS.EMPLOYEE_BENEFIT_INFORMATION,
    name: 'Employee Benefit',
    icon: Icons.Pension,
    bankName: 'Lorem Ipsum',
    accountNumber: '1234567890',
    percentage: 30,
    pageUrl: 'beneficiary/assign/employee'
  }
];

export const AllAsset = [
  {
    pageId: STEPS.BANK_INFORMATION,
    name: 'Bank Account',
    key: 'Bank',
    image: BankImage
  },
  {
    pageId: STEPS.STOCK_INFORMATION,
    name: 'Stocks/Shares',
    key: 'Stock',
    image: StockImage
  },
  {
    pageId: STEPS.PENSION_INFORMATION,
    name: 'Pension Fund Account',
    key: 'Pension',
    image: RSAImage
  },
  {
    pageId: STEPS.PHYSICAL_ASSETS_INFORMATION,
    name: 'Physical Asset',
    key: 'Physical',
    image: OtherImage
  },
  {
    pageId: STEPS.BOND_INFORMATION,
    name: 'Bond',
    key: 'Bond',
    image: BondImage
  },
  {
    pageId: STEPS.EMPLOYEE_BENEFIT_INFORMATION,
    name: 'Employee Benefit',
    key: 'Benefit',
    image: EmployeeImage
  }
];
